const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(51, 51, 51, 0.8)',
    zIndex: 20
  },
  content: {
    bottom: '5%',
    margin: '0 auto',
    maxHeight: '90%',
    minHeight: '400px',
    overflow: 'none',
    padding: 0,
    top: '5%',
    width: '750px'
  }
}

export default modalStyles
